import { Alert as MuiAlert, styled } from "@mui/material";
import { loginFormContainerName } from "../classes.js";
const Alert = styled(MuiAlert, {
  name: loginFormContainerName,
  slot: "Alert",
  overridesResolver: (_, styles) => styles.alert
})(() => ({
  width: "100%"
}));
export {
  Alert
};
//# sourceMappingURL=Alert.js.map
